var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "w100" },
    [
      _c(
        "w-breadcrumb",
        { attrs: { crumbs: _vm.crumbs } },
        [
          _c("w-spacer"),
          _c(
            "w-button",
            {
              on: {
                click: function ($event) {
                  return _vm.save()
                },
              },
            },
            [_vm._v(" " + _vm._s(_vm.$t("common.save")) + " ")]
          ),
        ],
        1
      ),
      _c(
        "w-scroll-view",
        { attrs: { tag: "w-container" } },
        [_c("app-reminder-template-edit", { attrs: { value: _vm.template } })],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }